import { sharedAssetUrl } from "@eweadn-qiankun/shared-assets";
import {
  isHfdSocdOnlyAdvancedKeyboard,
  isHuafendaMagneticAxisEquipment,
} from "@eweadn-qiankun/shared-utils";

const socdImg = sharedAssetUrl("theme/advancedKey/socd.png");
const rsImg = sharedAssetUrl("theme/advancedKey/rs.png");
const dksImg = sharedAssetUrl("theme/advancedKey/dks.png");
const mptImg = sharedAssetUrl("theme/advancedKey/mpt.png");
const mtImg = sharedAssetUrl("theme/advancedKey/mt.png");
const tglImg = sharedAssetUrl("theme/advancedKey/tgl.png");
const endImg = sharedAssetUrl("theme/advancedKey/end.png");
const cbImg = sharedAssetUrl("theme/advancedKey/cb.png");

/** 高级键分步向导：挂在各 mode 模板的 `wizard` 上，JSON clone 后即为 checkData.wizard；无 descKey 则 UI 不展示说明。第一步需选键个数由同条目的 selectData 数组长度决定。 */
export const advancedKeyWizardByEn: Record<
  string,
  {
    steps: Array<{ titleKey: string; descKey?: string }>;
  }
> = {
  SOCD: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.socd.step1Title",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.socd.step2Title",
        descKey: "keyboard.advancedKey.wizard.socd.step2Desc",
      },
    ],
  },
  RS: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.rs.step1Title",
        descKey: "keyboard.advancedKey.wizard.rs.step1Desc",
      },
    ],
  },
  SNAPKEY: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.snapkey.step1Title",
        descKey: "keyboard.advancedKey.wizard.snapkey.step1Desc",
      },
    ],
  },
  MDS: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.mds.step1Title",
        descKey: "keyboard.advancedKey.wizard.mds.step1Desc",
      },
    ],
  },
  DKS: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.dks.step1Title",
        descKey: "keyboard.advancedKey.wizard.dks.step1Desc",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.dks.step2Title",
      },
    ],
  },
  END: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.end.step1Title",
        descKey: "keyboard.advancedKey.wizard.end.step1Desc",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.end.step2Title",
        descKey: "keyboard.advancedKey.wizard.end.step2Desc",
      },
    ],
  },
  MT: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.mt.step1Title",
        descKey: "keyboard.advancedKey.wizard.mt.step1Desc",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.mt.step2Title",
        descKey: "keyboard.advancedKey.wizard.mt.step2Desc",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.mt.step3Title",
        descKey: "keyboard.advancedKey.wizard.mt.step3Desc",
      },
    ],
  },
  TGL: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.tgl.step1Title",
        descKey: "keyboard.advancedKey.wizard.tgl.step1Desc",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.tgl.step2Title",
        descKey: "keyboard.advancedKey.wizard.tgl.step2Desc",
      },
    ],
  },
  CB: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.cb.step1Title",
        descKey: "keyboard.advancedKey.wizard.cb.step1Desc",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.cb.step2Title",
        descKey: "keyboard.advancedKey.wizard.cb.step2Desc",
      },
    ],
  },
  MPT: {
    steps: [
      {
        titleKey: "keyboard.advancedKey.wizard.mpt.step1Title",
        descKey: "keyboard.advancedKey.wizard.mpt.step1Desc",
      },
      {
        titleKey: "keyboard.advancedKey.wizard.mpt.step2Title",
        descKey: "keyboard.advancedKey.wizard.mpt.step2Desc",
      },
    ],
  },
};

/** 若 checkData 尚无 wizard（例如旧逻辑构造的对象），按 en 补全 */
export function withAdvancedKeyWizard(data: any) {
  if (!data?.en) return data;
  if (data.wizard) return data;
  const cfg = advancedKeyWizardByEn[data.en];
  if (!cfg) return data;
  return { ...data, wizard: cfg };
}

export const originalData = [
  {
    en: "SOCD",
    cn: "智能处理反向指令冲突",
    title: "设定优先(SOCD)",
    titleKey: "keyboard.advancedKey.modeType.socd.title",
    descKey: "keyboard.advancedKey.modeType.socd.desc",
    value: 6,
    img: socdImg,
    icon: "socd",
    wizard: advancedKeyWizardByEn.SOCD,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: 0,
      delay: 50,
      kcs: [],
      /** 华奋达磁轴：快速触发行程 / RT（mm） */
      triggerKeyStroke: 1.5,
      pressRT: 0.3,
      releaseRT: 0.3,
      /** 华奋达磁轴 SOCD：是否开启快速触发 RT（勿与 mode 行为模式混用） */
      rtEnabled: true,
    },
    // 行为模式选项
    modeOptions: [
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.triggerLast",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.triggerLastDesc",
        value: 0,
      },
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.priority1",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.priority1Desc",
        value: 1,
      },
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.priority2",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.priority2Desc",
        value: 2,
      },
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.cancel",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.cancelDesc",
        value: 3,
      },
    ],
    // 提交的数据
    params: {
      row: "",
      col: "",
      row2: "",
      col2: "",
      mode: "",
      delay: "",
      kcs: [],
    },
  },
  {
    en: "RS",
    cn: "两个按键中会优先触发按下更深的按键",
    title: "迅洁(RS)",
    titleKey: "keyboard.advancedKey.modeType.rs.title",
    descKey: "keyboard.advancedKey.modeType.rs.desc",
    value: 7,
    img: rsImg,
    icon: "rs",
    wizard: advancedKeyWizardByEn.RS,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      delay: 50,
      kcs: [],
      /** 华奋达磁轴：快速触发行程（mm） */
      triggerKeyStroke: 1.5,
      pressRT: 0.3,
      releaseRT: 0.3,
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        row2: "",
        col2: "",
        delay: "",
        kcs: [],
      },
    },
  },
  {
    en: "DKS",
    cn: "根据一个按键按压深度实现4种功能",
    title: "动态键程(DKS)",
    titleKey: "keyboard.advancedKey.modeType.dks.title",
    descKey: "keyboard.advancedKey.modeType.dks.desc",
    value: 1,
    img: dksImg,
    icon: "dks",
    wizard: advancedKeyWizardByEn.DKS,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键(DKS各层级的键值数组，长度为4)
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        binaryData: [
          {
            key: 0,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 1,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 2,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 3,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 4,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 5,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 6,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 7,
            check: false,
            type: "circle",
            value: 0,
          },
        ],
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        binaryData: [
          {
            key: 0,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 1,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 2,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 3,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 4,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 5,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 6,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 7,
            check: false,
            type: "circle",
            value: 0,
          },
        ],
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        binaryData: [
          {
            key: 0,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 1,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 2,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 3,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 4,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 5,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 6,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 7,
            check: false,
            type: "circle",
            value: 0,
          },
        ],
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        binaryData: [
          {
            key: 0,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 1,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 2,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 3,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 4,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 5,
            check: false,
            type: "circle",
            value: 0,
          },
          {
            key: 6,
            check: false,
            type: "square",
            value: 0,
          },
          {
            key: 7,
            check: false,
            type: "circle",
            value: 0,
          },
        ],
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      trps: [], // 触发点行程参数，长度为4
      dbs: [1.4, 3.0], // DKS的死区设置数组，长度为2，单位为mm
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        kcs: [],
        trps: [],
        dbs: [],
      },
    },
  },
  {
    en: "MPT",
    cn: "单次按压过程中分阶段触发不同指令",
    title: "多段触发(MPT)",
    titleKey: "keyboard.advancedKey.modeType.mpt.title",
    descKey: "keyboard.advancedKey.modeType.mpt.desc",
    value: 2,
    img: mptImg,
    icon: "mpt",
    wizard: advancedKeyWizardByEn.MPT,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        value: 0.5,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        value: 1.0,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        value: 1.5,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      kcs: [],
      dbs: [],
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        kcs: [],
        dbs: [],
      },
    },
  },
  {
    en: "MT",
    cn: "一个按键绑定两种功能，按住为一种功能，单击为另一种功能",
    title: "双效点击(MT)",
    titleKey: "keyboard.advancedKey.modeType.mt.title",
    descKey: "keyboard.advancedKey.modeType.mt.desc",
    value: 3,
    img: mtImg,
    icon: "mt",
    wizard: advancedKeyWizardByEn.MT,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      time: 200,
      kcs: [],
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        time: [],
        kcs: [],
      },
    },
  },
  {
    en: "TGL",
    cn: "按键状态持久化",
    title: "火力全开(TGL)",
    titleKey: "keyboard.advancedKey.modeType.tgl.title",
    descKey: "keyboard.advancedKey.modeType.tgl.desc",
    value: 4,
    img: tglImg,
    icon: "tgl",
    wizard: advancedKeyWizardByEn.TGL,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      kcs: "",
      delay: 1,
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        kcs: "",
        delay: 0,
      },
    },
  },
  {
    en: "CB",
    cn: "一键触发多个修饰键与单个常规按键组合成组合指令",
    title: "组合键(CB)",
    titleKey: "keyboard.advancedKey.modeType.cb.title",
    descKey: "keyboard.advancedKey.modeType.cb.desc",
    value: 8,
    img: cbImg,
    icon: "cb",
    wizard: advancedKeyWizardByEn.CB,
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    otherData: {
      kcs: [],
    },
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        kcs: [],
      },
    },
  },
  {
    en: "END",
    cn: "按键回弹至设定位置时触发指令",
    title: "松开触发(END)",
    titleKey: "keyboard.advancedKey.modeType.end.title",
    descKey: "keyboard.advancedKey.modeType.end.desc",
    value: 5,
    img: endImg,
    icon: "end",
    wizard: advancedKeyWizardByEn.END,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      kcs: [],
      delay: 50,
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        kcs: [],
        delay: 0,
      },
    },
  },
  {
    en: "SNAPKEY",
    cn: "当两个按键被同时按下时，以最后按下的按键为准",
    title: "SnapKey",
    titleKey: "keyboard.advancedKey.modeType.snapkey.title",
    descKey: "keyboard.advancedKey.modeType.snapkey.desc",
    value: 9,
    img: "",
    icon: "snapkey",
    wizard: advancedKeyWizardByEn.SNAPKEY,
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    otherData: {
      mode: "",
      delay: 50,
      kcs: [],
    },
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        row2: "",
        col2: "",
        delay: "",
        kcs: [],
      },
    },
  },
  {
    en: "MDS",
    cn: "当两个按键被同时按下时将交替输出两个按键的值",
    title: "MDS",
    titleKey: "keyboard.advancedKey.modeType.mds.title",
    descKey: "keyboard.advancedKey.modeType.mds.desc",
    value: 10,
    img: "",
    icon: "mds",
    wizard: advancedKeyWizardByEn.MDS,
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    otherData: {
      mode: "",
      delay: 50,
      kcs: [],
    },
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        row2: "",
        col2: "",
        delay: "",
        kcs: [],
      },
    },
  },
];
export const originalDataBeiying = [
  {
    en: "SOCD",
    cn: "智能处理反向指令冲突",
    title: "设定优先(SOCD)",
    titleKey: "keyboard.advancedKey.modeType.socd.title",
    descKey: "keyboard.advancedKey.modeType.socd.desc",
    value: 6,
    img: socdImg,
    icon: "socd",
    wizard: advancedKeyWizardByEn.SOCD,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: 0,
      delay: 50,
      kcs: [],
      /** 华奋达磁轴：快速触发行程 / RT（mm） */
      triggerKeyStroke: 1.5,
      pressRT: 0.3,
      releaseRT: 0.3,
      /** 华奋达磁轴 SOCD：是否开启快速触发 RT（勿与 mode 行为模式混用） */
      rtEnabled: true,
    },
    // 行为模式选项
    modeOptions: [
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.triggerLast",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.triggerLastDesc",
        value: 0,
      },
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.priority1",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.priority1Desc",
        value: 1,
      },
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.priority2",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.priority2Desc",
        value: 2,
      },
      {
        labelKey: "keyboard.advancedKey.socdModes.modeOptions.cancel",
        descKey: "keyboard.advancedKey.socdModes.modeOptions.cancelDesc",
        value: 3,
      },
    ],
    // 提交的数据
    params: {
      row: "",
      col: "",
      row2: "",
      col2: "",
      mode: "",
      delay: "",
      kcs: [],
    },
  },
  {
    en: "MT",
    cn: "一个按键绑定两种功能，按住为一种功能，单击为另一种功能",
    title: "双效点击(MT)",
    titleKey: "keyboard.advancedKey.modeType.mt.title",
    descKey: "keyboard.advancedKey.modeType.mt.desc",
    value: 3,
    img: mtImg,
    icon: "mt",
    wizard: advancedKeyWizardByEn.MT,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      time: 200,
      kcs: [],
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        time: [],
        kcs: [],
      },
    },
  },
  {
    en: "TGL",
    cn: "按键状态持久化",
    title: "火力全开(TGL)",
    titleKey: "keyboard.advancedKey.modeType.tgl.title",
    descKey: "keyboard.advancedKey.modeType.tgl.desc",
    value: 4,
    img: tglImg,
    icon: "tgl",
    wizard: advancedKeyWizardByEn.TGL,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      kcs: "",
      delay: 1,
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        kcs: "",
        delay: 0,
      },
    },
  },
  {
    en: "END",
    cn: "按键回弹至设定位置时触发指令",
    title: "松开触发(END)",
    titleKey: "keyboard.advancedKey.modeType.end.title",
    descKey: "keyboard.advancedKey.modeType.end.desc",
    value: 5,
    img: endImg,
    icon: "end",
    wizard: advancedKeyWizardByEn.END,
    // 选择的按键
    selectData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
      },
    ],
    // 触发的按键
    triggerData: [
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
      {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
      },
    ],
    // 其他数据
    otherData: {
      mode: "",
      kcs: [],
      delay: 100,
    },
    // 提交的数据
    params: {
      row: "",
      col: "",
      mode: "",
      data: {
        kcs: [],
        delay: 0,
      },
    },
  },
];
/** 双键高级键 mode 值（SOCD / RS / SnapKey / MDS） */
export const DUAL_KEY_ADVANCED_MODE_VALUES = [6, 7, 9, 10] as const;

export function isDualKeyAdvancedModeValue(value: number): boolean {
  return (DUAL_KEY_ADVANCED_MODE_VALUES as readonly number[]).includes(value);
}

/** 容园方案仅支持 SnapKey / MT / MDS */
const RONGYUAN_ADVANCED_KEY_ORDER = ["SNAPKEY", "MT", "MDS"] as const;

/** 星闪方案（不含 CB；SnapKey / MDS 为容园专属） */
const XINGSHAN_ADVANCED_KEY_ORDER = [
  "SOCD",
  "RS",
  "DKS",
  "MPT",
  "MT",
  "TGL",
  "END",
] as const;

function buildAdvancedKeyCatalogFromOrder(order: readonly string[]) {
  return order.map((en) => {
    const item = originalData.find((x) => x.en === en);
    if (!item) {
      throw new Error(`[advancedKey] originalData 缺少 ${en}`);
    }
    return JSON.parse(JSON.stringify(item));
  });
}

export function resolveRongyuanAdvancedKeyCatalog() {
  return buildAdvancedKeyCatalogFromOrder(RONGYUAN_ADVANCED_KEY_ORDER);
}

export const originalDataRongyuan = buildAdvancedKeyCatalogFromOrder(
  RONGYUAN_ADVANCED_KEY_ORDER
);
const HFD_MAGNETIC_ADVANCED_KEY_ORDER = [
  "RS",
  "SOCD",
  "DKS",
  "MT",
  "TGL",
] as const;

/** 华奋达机械轴（X87 V2 / X87 Neon）：无 RS / DKS，支持 CB */
const HFD_MECHANICAL_ADVANCED_KEY_ORDER = ["SOCD", "MT", "TGL", "CB"] as const;

/** 华奋达磁轴 DKS：起始 / 触底 / 触底抬起 / 完全抬起 */
export const HFD_MAGNETIC_DKS_DEFAULT_DBS = [1.6, 3, 3, 1.6] as const;

export function resolveMagneticDksDefaultDbs(
  _keyboardType?: string | null
): readonly number[] {
  return HFD_MAGNETIC_DKS_DEFAULT_DBS;
}

function buildHuafendaAdvancedKeyCatalog(
  order: readonly string[],
  equipment?: unknown
) {
  return order.map((en) => {
    const item = originalData.find((x) => x.en === en);
    if (!item) {
      throw new Error(`[advancedKey] originalData 缺少 ${en}`);
    }
    const cloned = JSON.parse(JSON.stringify(item));
    if (en === "DKS") {
      const kt = String(
        (equipment as { keyboardType?: string })?.keyboardType ?? ""
      ).trim();
      cloned.otherData = {
        ...cloned.otherData,
        dbs: [...resolveMagneticDksDefaultDbs(kt)],
      };
    }
    return cloned;
  });
}

/** 按设备能力返回华丰达高级键模式列表 */
export function resolveHuafendaAdvancedKeyCatalog(equipment: unknown) {
  if (isHfdSocdOnlyAdvancedKeyboard(equipment as any)) {
    return buildHuafendaAdvancedKeyCatalog(["SOCD"]);
  }
  if (isHuafendaMagneticAxisEquipment(equipment as any)) {
    return buildHuafendaAdvancedKeyCatalog(
      HFD_MAGNETIC_ADVANCED_KEY_ORDER,
      equipment
    );
  }
  return buildHuafendaAdvancedKeyCatalog(
    HFD_MECHANICAL_ADVANCED_KEY_ORDER,
    equipment
  );
}

/** 无设备上下文时的兜底（磁轴完整列表） */
export const originalDataHuafenda = buildHuafendaAdvancedKeyCatalog(
  HFD_MAGNETIC_ADVANCED_KEY_ORDER
);

/** 星闪高级键模式（白名单，与固件/SDK 能力一致） */
export function buildXingshanAdvancedKeyCatalog() {
  return buildAdvancedKeyCatalogFromOrder(XINGSHAN_ADVANCED_KEY_ORDER);
}
